import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Authenticity } from './pages/Authenticity';
import { CrewRewards } from './pages/CrewRewards';
import { Activate } from './pages/Activate';
import { Guide } from './pages/Guide';
import { TrackOrder } from './pages/TrackOrder';
import { ScrollToHash } from './components/ScrollToHash';
import { PixelRouteTracker } from './components/PixelRouteTracker';
import { initPixels } from './utils/tracking';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  // Loads the Meta Pixel once and fires PageView as soon as the site loads, on any page.
  useEffect(() => {
    initPixels();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="23u9v6r043jyv">
      <ScrollToHash data-id="element-1" data-mp="23utadzydnu97" />
      <PixelRouteTracker data-id="element-2" data-mp="23ti8y6semyl9" />
      <Routes data-id="element-3" data-mp="3ik7k0rkruvvx">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-5" data-mp="3ihv1odb3qjic" />} data-id="element-4" data-mp="3ikqy1x7ax04o" />
        <Route path="/verify" element={<Authenticity data-id="element-7" data-mp="3rcj6618urx63" />} data-id="element-6" data-mp="3mjpyp5m02aqb" />
        <Route path="/rewards" element={<CrewRewards data-id="element-9" data-mp="3rd1azm9kzjpm" />} data-id="element-8" data-mp="3rbzpsoyupgu6" />
        <Route path="/activate" element={<Activate data-id="element-11" data-mp="67yhm9c7y5s" />} data-id="element-10" data-mp="3relwkmdx3sbc" />
        <Route path="/guide" element={<Guide data-id="element-13" data-mp="82j0zgp5o9c" />} data-id="element-12" data-mp="4n725ibkvc5" />
        <Route path="/track" element={<TrackOrder data-id="element-15" data-mp="2zlv32jnmchps" />} data-id="element-14" data-mp="2zl3dbpgpde7f" />
        <Route path="/legal/:slug" element={<Legal data-id="element-17" data-mp="33mov9p83gioh" />} data-id="element-16" data-mp="2zmo5j8fjol24" />
        <Route path="*" element={<Legal data-id="element-19" data-mp="33nq921ghvj9w" />} data-id="element-18" data-mp="33m5cy7ej7s9x" />
      </Routes>
    </BrowserRouter>;
}